/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportListCreateRequest = {
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  type: ReportListCreateRequest.type
  workflow?: string
  model?: string
  simulation_job?: string
  training_data?: string
  dataset?: string
  /**
   * Should be in ISO format (YYYY-MM-DDTHH:mm:ss)
   */
  predictions_start_time?: string
  /**
   * Should be in ISO format (YYYY-MM-DDTHH:mm:ss)
   */
  predictions_end_time?: string
}
export namespace ReportListCreateRequest {
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  export enum type {
    DATASET = "DATASET",
    TRAINING_DATA = "TRAINING_DATA",
    PREDICTION = "PREDICTION",
    WORKFLOW_PREDICTION = "WORKFLOW_PREDICTION",
    MODEL_PREDICTION = "MODEL_PREDICTION",
    SIMULATION = "SIMULATION",
  }
}
